import React from "react";
import HeaderBottom from "../assets/header-bottom-shap.png";
import HotelGallery from "../components/HotelGallery";
import HotelDetailsGallery from "../components/HotelDetailsGallery";
import AvailabilityDetails from "../components/AvailabilityDetails";
import RoomTypeDetails from "../components/RoomTypeDetails";

const HotelDetails = () => {
  return (
    <main className="main position-relative">
      <div className="bottom-main-shap position-absolute top-0">
        <img src={HeaderBottom} alt="" />
      </div>
      <HotelGallery />
      <HotelDetailsGallery />
      <AvailabilityDetails />
      <RoomTypeDetails />
    </main>
  );
};

export default HotelDetails;
